module.exports = __webpack_public_path__ + "img/img-display.1c0685a9.svg";